// Curated whitelist of Lucide icon names offered for custom tiles. The same
// names exist in lucide-react (admin) and lucide-react-native (mobile), so a
// tile's stored `icon` string renders identically on both sides.
// Keep this list in sync with mobile/src/lib/customTileIcons.ts.
export const CUSTOM_TILE_ICONS = [
    'LayoutGrid', 'Phone', 'Mail', 'MapPin', 'Calendar', 'CalendarDays', 'Clock',
    'FileText', 'ClipboardList', 'Newspaper', 'BookOpen', 'Library', 'GraduationCap',
    'Bus', 'Car', 'Bike', 'TrainFront', 'ParkingCircle', 'TrafficCone',
    'Trash2', 'Recycle', 'Leaf', 'TreePine', 'Flower2', 'Sprout',
    'Heart', 'HeartHandshake', 'Stethoscope', 'Pill', 'Cross', 'Activity',
    'Euro', 'CreditCard', 'Wallet', 'Receipt', 'Landmark', 'Building2', 'Building',
    'Home', 'Store', 'ShoppingBag', 'ShoppingCart', 'Utensils', 'Coffee',
    'Users', 'User', 'Baby', 'Accessibility', 'HandHeart', 'Handshake',
    'Music', 'Theater', 'Palette', 'Camera', 'Film', 'Ticket', 'PartyPopper',
    'Trophy', 'Dumbbell', 'Bike', 'Waves', 'Mountain', 'Tent', 'Footprints',
    'Wrench', 'Hammer', 'Construction', 'Lightbulb', 'Zap', 'Droplet', 'Flame',
    'Wifi', 'Globe', 'Link', 'Megaphone', 'Bell', 'Info', 'HelpCircle',
    'Shield', 'Siren', 'AlertTriangle', 'Scale', 'Gavel', 'Vote', 'Flag',
    'Star', 'MessageCircle', 'Send', 'Briefcase', 'Package', 'Gift', 'Key',
    'Sun', 'CloudSun', 'Umbrella', 'Snowflake', 'Map', 'Compass', 'Navigation',
];
// French search aliases per icon, so an agent typing e.g. "poubelle" finds Trash2
// or "téléphone" finds Phone. Matching is accent/case-insensitive (see IconPicker).
export const CUSTOM_TILE_ICON_ALIASES = {
    LayoutGrid: ['grille', 'tuiles', 'menu', 'services', 'application'],
    Phone: ['telephone', 'appel', 'appeler', 'contact', 'numero'],
    Mail: ['email', 'courriel', 'mail', 'message', 'contact', 'enveloppe'],
    MapPin: ['carte', 'localisation', 'adresse', 'lieu', 'position', 'plan', 'epingle'],
    Calendar: ['calendrier', 'agenda', 'date', 'rendez-vous', 'rdv'],
    CalendarDays: ['calendrier', 'agenda', 'evenements', 'dates', 'planning'],
    Clock: ['horloge', 'heure', 'horaires', 'temps', 'duree'],
    FileText: ['document', 'fichier', 'formulaire', 'demarche', 'papier', 'texte'],
    ClipboardList: ['liste', 'formulaire', 'demarche', 'inscription', 'presse-papier'],
    Newspaper: ['journal', 'actualites', 'news', 'presse', 'articles', 'bulletin'],
    BookOpen: ['livre', 'lecture', 'bibliotheque', 'guide', 'documentation'],
    Library: ['bibliotheque', 'mediatheque', 'livres', 'culture'],
    GraduationCap: ['ecole', 'education', 'scolaire', 'diplome', 'etudes', 'universite'],
    Bus: ['bus', 'transport', 'transports', 'navette', 'autobus'],
    Car: ['voiture', 'auto', 'vehicule', 'transport', 'stationnement'],
    Bike: ['velo', 'cycliste', 'cyclable', 'bicyclette', 'mobilite'],
    TrainFront: ['train', 'gare', 'transport', 'sncf', 'tram'],
    ParkingCircle: ['parking', 'stationnement', 'parc', 'voiture', 'garer'],
    TrafficCone: ['travaux', 'chantier', 'cone', 'route', 'circulation'],
    Trash2: ['poubelle', 'dechets', 'ordures', 'corbeille', 'collecte', 'tri'],
    Recycle: ['recyclage', 'tri', 'dechets', 'environnement', 'ecologie'],
    Leaf: ['feuille', 'nature', 'environnement', 'ecologie', 'vert', 'espaces verts'],
    TreePine: ['arbre', 'sapin', 'foret', 'nature', 'parc', 'espaces verts'],
    Flower2: ['fleur', 'jardin', 'fleurissement', 'nature', 'parc'],
    Sprout: ['pousse', 'jardin', 'plantation', 'nature', 'potager', 'jardinage'],
    Heart: ['coeur', 'sante', 'solidarite', 'don', 'favori', 'social'],
    HeartHandshake: ['solidarite', 'entraide', 'social', 'don', 'aide', 'caritatif'],
    Stethoscope: ['medecin', 'sante', 'docteur', 'medical', 'soin', 'consultation'],
    Pill: ['pharmacie', 'medicament', 'sante', 'medical', 'garde'],
    Cross: ['croix', 'sante', 'secours', 'hopital', 'medical', 'urgence'],
    Activity: ['activite', 'sante', 'pouls', 'sport', 'suivi'],
    Euro: ['euro', 'argent', 'paiement', 'tarif', 'prix', 'finances', 'budget'],
    CreditCard: ['carte', 'paiement', 'bancaire', 'payer', 'carte bancaire'],
    Wallet: ['portefeuille', 'paiement', 'argent', 'cartes', 'wallet'],
    Receipt: ['facture', 'recu', 'ticket', 'paiement', 'depense'],
    Landmark: ['mairie', 'institution', 'monument', 'administration', 'batiment public', 'banque'],
    Building2: ['batiment', 'mairie', 'immeuble', 'administration', 'bureau'],
    Building: ['batiment', 'immeuble', 'edifice', 'logement'],
    Home: ['maison', 'accueil', 'domicile', 'logement', 'habitat'],
    Store: ['commerce', 'boutique', 'magasin', 'marche', 'commercant'],
    ShoppingBag: ['shopping', 'achats', 'commerce', 'sac', 'boutique'],
    ShoppingCart: ['panier', 'courses', 'achats', 'commerce', 'caddie'],
    Utensils: ['restaurant', 'cantine', 'repas', 'restauration', 'couverts', 'menu'],
    Coffee: ['cafe', 'bar', 'pause', 'boisson', 'restauration'],
    Users: ['personnes', 'groupe', 'citoyens', 'habitants', 'communaute', 'association'],
    User: ['personne', 'compte', 'profil', 'utilisateur', 'citoyen'],
    Baby: ['bebe', 'enfance', 'creche', 'petite enfance', 'nourrisson'],
    Accessibility: ['accessibilite', 'handicap', 'pmr', 'mobilite reduite', 'inclusion'],
    HandHeart: ['don', 'solidarite', 'benevolat', 'aide', 'social', 'caritatif'],
    Handshake: ['partenariat', 'accord', 'entraide', 'collaboration', 'poignee de main'],
    Music: ['musique', 'concert', 'culture', 'festival', 'spectacle'],
    Theater: ['theatre', 'spectacle', 'culture', 'scene', 'representation'],
    Palette: ['art', 'culture', 'peinture', 'atelier', 'couleurs', 'creation'],
    Camera: ['photo', 'appareil', 'image', 'cliche', 'photographie'],
    Film: ['cinema', 'film', 'video', 'projection', 'culture'],
    Ticket: ['billet', 'ticket', 'reservation', 'entree', 'place', 'spectacle'],
    PartyPopper: ['fete', 'evenement', 'celebration', 'festivites', 'animation'],
    Trophy: ['trophee', 'sport', 'competition', 'recompense', 'prix', 'concours'],
    Dumbbell: ['sport', 'musculation', 'gym', 'fitness', 'salle de sport'],
    Waves: ['piscine', 'eau', 'mer', 'plage', 'vagues', 'baignade'],
    Mountain: ['montagne', 'randonnee', 'nature', 'sommet', 'sentier'],
    Tent: ['camping', 'tente', 'tourisme', 'bivouac', 'plein air'],
    Footprints: ['randonnee', 'marche', 'sentier', 'promenade', 'pas', 'balade'],
    Wrench: ['outil', 'reparation', 'maintenance', 'technique', 'cle', 'bricolage'],
    Hammer: ['marteau', 'travaux', 'bricolage', 'construction', 'reparation'],
    Construction: ['travaux', 'chantier', 'construction', 'voirie', 'route'],
    Lightbulb: ['idee', 'ampoule', 'projet', 'eclairage', 'innovation', 'lumiere'],
    Zap: ['eclair', 'energie', 'electricite', 'rapide', 'foudre'],
    Droplet: ['eau', 'goutte', 'assainissement', 'fontaine', 'liquide'],
    Flame: ['feu', 'flamme', 'pompiers', 'incendie', 'chaleur', 'energie'],
    Wifi: ['wifi', 'internet', 'connexion', 'reseau', 'numerique'],
    Globe: ['monde', 'site', 'internet', 'web', 'international', 'planete'],
    Link: ['lien', 'url', 'site', 'web', 'redirection'],
    Megaphone: ['annonce', 'communication', 'porte-voix', 'information', 'alerte'],
    Bell: ['cloche', 'notification', 'alerte', 'rappel', 'sonnerie'],
    Info: ['information', 'infos', 'renseignement', 'aide', 'details'],
    HelpCircle: ['aide', 'question', 'faq', 'support', 'assistance'],
    Shield: ['bouclier', 'securite', 'protection', 'police', 'prevention'],
    Siren: ['alerte', 'urgence', 'sirene', 'police', 'pompiers', 'secours'],
    AlertTriangle: ['alerte', 'attention', 'danger', 'avertissement', 'signalement', 'vigilance'],
    Scale: ['justice', 'balance', 'droit', 'affichage legal', 'equite', 'reglement'],
    Gavel: ['marteau', 'conseil', 'justice', 'deliberation', 'seance', 'municipal'],
    Vote: ['vote', 'election', 'urne', 'sondage', 'consultation', 'participation'],
    Flag: ['drapeau', 'signalement', 'reperer', 'marquer', 'pays'],
    Star: ['etoile', 'favori', 'note', 'avis', 'evaluation', 'qualite'],
    MessageCircle: ['message', 'discussion', 'contact', 'chat', 'messagerie', 'ticket'],
    Send: ['envoyer', 'message', 'envoi', 'transmettre', 'avion'],
    Briefcase: ['emploi', 'travail', 'entreprise', 'professionnel', 'mallette', 'economie'],
    Package: ['colis', 'paquet', 'livraison', 'boite', 'envoi'],
    Gift: ['cadeau', 'don', 'offre', 'recompense', 'present'],
    Key: ['cle', 'acces', 'logement', 'securite', 'reservation', 'location'],
    Sun: ['soleil', 'meteo', 'beau temps', 'ensoleille', 'jour'],
    CloudSun: ['meteo', 'nuage', 'soleil', 'previsions', 'temps'],
    Umbrella: ['parapluie', 'pluie', 'meteo', 'protection', 'abri'],
    Snowflake: ['neige', 'froid', 'hiver', 'flocon', 'gel', 'meteo'],
    Map: ['carte', 'plan', 'localisation', 'territoire', 'itineraire'],
    Compass: ['boussole', 'orientation', 'direction', 'tourisme', 'decouverte'],
    Navigation: ['navigation', 'gps', 'itineraire', 'direction', 'aller'],
};
/** Lowercase and strip diacritics so "téléphone" matches "telephone". */
export function normalizeSearch(value) {
    return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}
/** Whether an icon matches a (normalized) French/English query via its name or aliases. */
export function iconMatchesQuery(name, normalizedQuery) {
    if (normalizeSearch(name).includes(normalizedQuery))
        return true;
    return (CUSTOM_TILE_ICON_ALIASES[name] ?? []).some((alias) => normalizeSearch(alias).includes(normalizedQuery));
}
// Palette offered for the tile icon color (matches the predefined-swatch pattern
// used elsewhere, e.g. report categories). The first entry is the brand green.
export const CUSTOM_TILE_COLORS = [
    '#2ECC71', '#10B981', '#3B82F6', '#0EA5E9', '#6366F1', '#8B5CF6',
    '#A855F7', '#EC4899', '#EF4444', '#F97316', '#F59E0B', '#EAB308',
    '#14B8A6', '#6B7280',
];
